"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoPreferences = exports.MutableVideoPreferences = void 0;

var ObjectSet = /*#__PURE__*/function (_Symbol$iterator) {
  function ObjectSet() {
    var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _classCallCheck(this, ObjectSet);

    this.items = items;
  }

  _createClass(ObjectSet, [{
    key: _Symbol$iterator,
    value: // Returns the items in sorted order.
    function value() {
      var i = 0;
      var items = this.items;
      return {
        next: function next() {
          if (i < items.length) {
            return {
              done: false,
              value: items[i++]
            };
          }

          return {
            done: true,
            value: null
          };
        }
      };
    }
  }, {
    key: "first",
    value: function first() {
      return this.items[0];
    }
  }, {
    key: "add",
    value: function add(item) {
      // If this is used elsewhere, there needs to be a duplicate check here
      this.items.push(item);
    }
  }, {
    key: "replaceFirst",
    value: function replaceFirst(newItem, f) {
      var pos = this.items.findIndex(f);

      if (pos === -1) {
        // If this is used elsewhere, there needs to be a duplicate check here
        this.items.push(newItem);
      } else if (!this.has(newItem)) {
        this.items[pos] = newItem;
      } else {
        this.items.splice(pos, 1);
      }
    }
  }, {
    key: "remove",
    value: function remove(item) {
      this.items = this.items.filter(function (a) {
        return !a.equals(item);
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      this.items = [];
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.items.length === 0;
    }
  }, {
    key: "equals",
    value: function equals(other) {
      if (other === this) {
        return true;
      }

      if (other.items.length !== this.items.length) {
        return false;
      } // TODO: if we keep the arrays sorted correctly, not just by priority, then
      // we don't need to do this painstaking O(n^2) work.


      var _iterator = _createForOfIteratorHelper(this.items),
          _step;

      try {
        var _loop = function _loop() {
          var item = _step.value;

          if (!other.items.some(function (a) {
            return a.equals(item);
          })) {
            return {
              v: false
            };
          }
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ret = _loop();

          if (_typeof(_ret) === "object") return _ret.v;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return true;
    }
  }, {
    key: "has",
    value: function has(item) {
      return this.items.some(function (a) {
        return a.equals(item);
      });
    }
  }, {
    key: "some",
    value: function some(f) {
      return this.items.some(f);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new ObjectSet(_toConsumableArray(this.items));
    }
  }, {
    key: "sort",
    value: function sort() {
      this.items.sort(function (a, b) {
        return a.partialCompare(b);
      });
    }
  }, {
    key: "modify",
    value: function modify() {
      // COW.
      return new SetBuilder(this);
    }
  }], [{
    key: "default",
    value: function _default() {
      return new ObjectSet([]);
    }
  }]);

  return ObjectSet;
}(Symbol.iterator);

var SetBuilder = /*#__PURE__*/function () {
  function SetBuilder() {
    var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new ObjectSet();

    _classCallCheck(this, SetBuilder);

    this.items = items;
    this.copied = false;
  }

  _createClass(SetBuilder, [{
    key: "cow",
    value: function cow() {
      if (this.copied) {
        return;
      }

      this.items = this.items.clone();
      this.copied = true;
    }
  }, {
    key: "add",
    value: function add(item) {
      // Don't actually need to COW unless the item is there to add.
      if (this.items.has(item)) {
        return;
      }

      this.cow();
      this.items.add(item);
    }
  }, {
    key: "replaceFirst",
    value: function replaceFirst(newItem, f) {
      // Don't actually need to COW unless the item is already there
      // and there are no items to replace
      if (this.items.has(newItem) && !this.items.some(f)) {
        return;
      }

      this.cow();
      this.items.replaceFirst(newItem, f);
    }
  }, {
    key: "remove",
    value: function remove(item) {
      // Don't actually need to COW unless the item is there to remove.
      if (!this.items.has(item)) {
        return;
      }

      this.cow();
      this.items.remove(item);
    }
  }, {
    key: "some",
    value: function some(f) {
      return this.items.some(f);
    }
  }, {
    key: "clear",
    value: function clear() {
      if (this.items.isEmpty()) {
        return;
      }

      this.cow();
      this.items.clear();
    }
  }, {
    key: "build",
    value: function build() {
      // Immutable sets are always kept sorted!
      if (this.copied) {
        this.items.sort();
      }

      this.copied = false;
      return this.items;
    }
  }]);

  return SetBuilder;
}();

var MutableVideoPreferences = /*#__PURE__*/function () {
  function MutableVideoPreferences(builder) {
    _classCallCheck(this, MutableVideoPreferences);

    this.builder = builder;
  }

  _createClass(MutableVideoPreferences, [{
    key: "add",
    value: function add(pref) {
      this.builder.add(pref);
    }
  }, {
    key: "replaceFirst",
    value: function replaceFirst(newPref, f) {
      this.builder.replaceFirst(newPref, f);
    }
  }, {
    key: "remove",
    value: function remove(pref) {
      this.builder.remove(pref);
    }
  }, {
    key: "some",
    value: function some(f) {
      return this.builder.some(f);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.builder.clear();
    }
  }, {
    key: "build",
    value: function build() {
      return new VideoPreferences(this.builder.build());
    }
  }]);

  return MutableVideoPreferences;
}();

exports.MutableVideoPreferences = MutableVideoPreferences;

var VideoPreferences = /*#__PURE__*/function (_Symbol$iterator2) {
  /** @internal */
  function VideoPreferences(items) {
    _classCallCheck(this, VideoPreferences);

    this.items = items;
  }

  _createClass(VideoPreferences, [{
    key: _Symbol$iterator2,
    value: function value() {
      return this.items[Symbol.iterator]();
    }
  }, {
    key: "highestPriority",
    value: function highestPriority() {
      var _a;

      return (_a = this.items.first()) === null || _a === void 0 ? void 0 : _a.priority;
    } // Our items happen to always be sorted!

  }, {
    key: "sorted",
    value: function sorted() {
      return this.items[Symbol.iterator]();
    }
  }, {
    key: "equals",
    value: function equals(other) {
      return other === this || this.items.equals(other.items);
    }
  }, {
    key: "modify",
    value: function modify() {
      return new MutableVideoPreferences(this.items.modify());
    }
  }, {
    key: "some",
    value: function some(f) {
      return this.items.some(f);
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.items.isEmpty();
    }
  }], [{
    key: "prepare",
    value: function prepare() {
      return new MutableVideoPreferences(new SetBuilder());
    }
  }, {
    key: "default",
    value: function _default() {
      return new VideoPreferences(ObjectSet.default());
    }
  }]);

  return VideoPreferences;
}(Symbol.iterator);

exports.VideoPreferences = VideoPreferences;
exports.default = VideoPreferences;